export default function getSubdomain() {
  if (typeof window !== 'undefined') {
    const { hostname } = window.location;
    const parts = hostname.split('.');

    if (parts.length >= 2) {
      // "staging" and "www" don't count as subdomains for our purposes
      if (parts[0] !== 'staging' && parts[0] !== 'www') {
        return parts[0];
      }
    }
  }
  return null;
}
